import axios, { AxiosInstance } from 'axios';

import { env } from '@/env';
import { AuthenticationContext } from '../auth/authentication-context';
import useRequestInterceptors from './interceptors/request';
import useResponseInterceptors from './interceptors/response';

export class HttpClient {
  public instance: AxiosInstance;
  public authContext!: AuthenticationContext;  
  
  constructor() {
    this.instance = axios.create();

    useRequestInterceptors(this);
    useResponseInterceptors(this);
  }

  public setAuthContext(authContext: AuthenticationContext) {
    this.authContext = authContext;
  }
}

export default new HttpClient();
